import { Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardCartAndSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/dashboard-cart-and-settings';
import { SetValueAction } from '@common-modules/dynamic-layout/state/generic/generic.actions';
import { ReduxStateService } from '@common-modules/redux/redux-state.service';
import { DashboardManagerService } from '@common-modules/right-panel/dashboards/dashboard-manager.service';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import { IFiltrableItemDto } from '@common-modules/shared/model/filtrable-items/filtrable-item.dto';
import { DataVisualizationStateFields } from '@water-loss/features/data-visualization/models/data-visualization-state-fields';
import { Observable } from 'rxjs';
import { DashboardChildConfigComponent } from '../dashboard-child-config/dashboard-child-config.component';
import { DashboardChildConfigPopupData } from './dashboard-child-config-popup-data';

const COMPONENT_SELECTOR = 'ct-dashboard-child-config-popup';

@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './dashboard-child-config-popup.component.html',
  styleUrl: './dashboard-child-config-popup.component.scss',
  standalone: false,
})
export class DashboardChildConfigPopupComponent implements OnInit {
  @ViewChild(DashboardChildConfigComponent)
  dashboardChildConfigComponent: DashboardChildConfigComponent;

  readonly T_SCOPE = `${AppModules.RightPanel}.${COMPONENT_SELECTOR}`;
  private readonly _dialogRef = inject(MatDialogRef<DashboardChildConfigPopupComponent>);
  private readonly _dashboardManagerService = inject(DashboardManagerService);
  private readonly _state = inject(ReduxStateService);

  cartAndSettings: DashboardCartAndSettings;
  newItems: IFiltrableItemDto[];
  newVisibleItems: IFiltrableItemDto[];
  isLoading = false;
  isValid = true;

  constructor(@Inject(MAT_DIALOG_DATA) data: DashboardChildConfigPopupData) {
    this.cartAndSettings = data;
  }

  ngOnInit() {
    this._dashboardManagerService.updateCartAndSettingsInSettingsComponet$.subscribe((result) => {
      this.newItems = result.items;
      this.newVisibleItems = result.visibleItems;
    });
  }

  onSave(): void {
    this.buildCartAndSettings().subscribe((cartAndSettings) => {
      this._state.dispatch(
        new SetValueAction({
          fieldName: DataVisualizationStateFields.widgetSettingUpdate,
          value: cartAndSettings.widgetSettings,
        })
      );
      this._dialogRef.close(cartAndSettings);
    });
  }

  buildCartAndSettings(): Observable<DashboardCartAndSettings> {
    return this.dashboardChildConfigComponent.buildCartAndSettings();
  }

  onValidChange(isValid: boolean): void {
    this.isValid = isValid;
  }

  cancel(event): void {
    this._dialogRef.close();
  }
}
